import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { msalInstance } from "../../auth-config";
import { AppConstants } from "../../constants";

// Silent first. When the session has expired, send the user to sign in instead of failing every request
export async function getAccessToken(): Promise<string> {
  const request = {
    scopes: [AppConstants.apiScopes],
    account: msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0],
  };

  try {
    return (await msalInstance.acquireTokenSilent(request)).accessToken;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      await msalInstance.acquireTokenRedirect(request);
    }
    throw error;
  }
}
